// extracted by mini-css-extract-plugin
module.exports = {"list":"_82e3db2ea0--list--z_Na6","phone":"_82e3db2ea0--phone--UXLsN","tablet":"_82e3db2ea0--tablet--F3LZe","desktop":"_82e3db2ea0--desktop--xMiSG"};